<script>
import scroll from 'scroll';

export default {
  name: 'ScrollElement',
  data: () => ({
    scrollPercentage: null,
    isScrollable: true,
  }),
  props: {
    paddingTop: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    scroll (value) {
      const el = this.$el.querySelector('.scrollcontainer');
      scroll.top(el, el.scrollTop + value, undefined, this.onScroll);
    },
    scrollDown () {
      this.scroll(130);
    },
    scrollTop () {
      this.scroll(-130);
    },
    onScroll () {
      const element = this.$el.querySelector('.scrollcontainer');
      this.scrollPercentage = this.getScrollPercent(element);
    },
    getScrollPercent (element) {
      return Math.round(element.scrollTop * 100 / Math.max(element.scrollHeight - element.clientHeight, 1));
    },
    checkScrollAvaibility () {
      this.isScrollable = this.$el.querySelector('.scrollcontainer').scrollHeight + this.paddingTop > this.$el.scrollHeight;
    },
  },
  created () {
    const computeHeight = () => {
      this.scrollPercentage = this.getScrollPercent(this.$el.querySelector('.scrollcontainer'));
      this.checkScrollAvaibility();
    };
    this.$nextTick(() => {
      computeHeight();
      this.__observer = new MutationObserver(computeHeight);
      this.__observer.observe(this.$el.querySelector('.scrollcontainer'), { childList: true, subtree: true });
    });
  },
  destroyed () {
    this.__observer.disconnect();
  },
  computed: {
    canScrollBottom () {
      return this.scrollPercentage !== null && this.isScrollable && this.scrollPercentage < 100;
    },
    canScrollTop () {
      return this.scrollPercentage !== null && this.isScrollable && this.scrollPercentage > 0;
    },
  },
};
</script>

<template lang="pug">
div.scroll-element.relative.overflow-hidden(v-bar="{ preventParentScroll:true, useScrollbarPseudo:true }" :style="{ paddingTop: `${paddingTop}px` }")
  div.scrollcontainer.vb-content(@scroll="onScroll", :class="{'-can-up': canScrollTop, '-can-down': canScrollBottom}")
    slot
  transition(enter-active-class="animated slideInDown")
    div.absolute.top-0.w-100(v-show="canScrollTop")
      arrow-button.scrolltopbtn.pa1.center.db.rotate-180(small, @click="scrollTop")
  transition(enter-active-class="animated slideInUp")
    div.absolute.bottom-0.w-100(v-show="canScrollBottom")
      arrow-button.scrollbottombtn.pa1.center.db(small, @click="scrollDown")
</template>

<style scoped>
.scroll-element {
  height: 0px;
  & .scrollcontainer {
    --fadeStart: 2.5rem;
    --fadeEnd: 7rem;
    &.-can-up {
      mask-image: linear-gradient(
        to bottom,
        transparent var(--fadeStart),
        black var(--fadeEnd)
      );
    }
    &.-can-down {
      mask-image: linear-gradient(
        to top,
        transparent var(--fadeStart),
        black var(--fadeEnd)
      ); /*NOTE HACK POLYFILL*/
    }
    &.-can-up.-can-down {
      mask-image: linear-gradient(
          to bottom,
          transparent var(--fadeStart),
          black var(--fadeEnd),
          black 50%,
          transparent 50%
        ),
        linear-gradient(
          to top,
          transparent var(--fadeStart),
          black var(--fadeEnd),
          black 50%,
          transparent 50%
        );
    }
  }
}
</style>
